import { ComponentProps } from "react";
import { twMerge } from "tailwind-merge";

interface CardProps extends ComponentProps<"div"> {}

export const Card = (props: CardProps) => {
  return (
    <div
      {...props}
      className={twMerge("card-treining py-8 px-4", props.className)}
    ></div>
  );
};
